<template>
  <div class="details_box">
    <!-- 訂單詳情 -->
    <div class="deal_content_box" v-loading="inquireTF">
        <div class="deal_content_title">訂單詳情</div>
        <!-- 內容 -->
        <div class="deal_content">
          <!-- box -->
          <div class="content_box">
            <!-- 箭頭-box -->
            <!-- <p class="arrows_box">
              <span @click="detailsPN(previousId, branchType, previousBranchType)"><i class="el-icon-caret-left"></i>上一筆</span>
              <span @click="detailsPN(nextId, branchType, nextBranchType)">下一筆<i class="el-icon-caret-right"></i></span>
            </p> -->
            <!-- 箭頭-end -->
            <!-- 表單 -->
            <div class="table_box">
              <div>
                <p class="table_title">UID</p>
                <p class="table_content">{{this.$store.state.detailsList.uid}}</p>
              </div>
              <div>
                <p class="table_title">商戶訂單號</p>
                <p class="table_content">{{this.$store.state.detailsList.order_no}}</p>
              </div>
              <div>
                <p class="table_title">支付單號</p>
                <p class="table_content">{{this.$store.state.detailsList.pay_no}}</p>
              </div>
              <div>
                <p class="table_title">交易時間</p>
                <p class="table_content">{{this.$store.state.detailsList.createtime}}</p>
              </div>
              <div>
                <p class="table_title">付款類型</p>
                <p class="table_content">{{this.$store.state.detailsList.channel}}</p>
              </div>
              <div>
                <p class="table_title">交易狀態</p>
                <p class="table_content">{{this.$store.state.detailsList.status}}</p>
              </div>
              <div>
                <p class="table_title">應結金額</p>
                <p class="table_content">{{this.$store.state.detailsList.settlement_amount}}</p>
              </div>
              <div>
                <p class="table_title">週期</p>
                <p class="table_content">{{this.$store.state.detailsList.settlement_cycle}}</p>
              </div>
              <div>
                <p class="table_title">手續費</p>
                <p class="table_content">{{this.$store.state.detailsList.service_amount}}</p>
              </div>
              <div>
                <p class="table_title">實際金額</p>
                <!-- {{this.$store.state.detailsList.amount}} -->
                <p class="table_content"></p>
              </div>
              <div>
                <p class="table_title">到帳時間</p>
                <p class="table_content">{{this.$store.state.detailsList.paytime}}</p>
              </div>
              <div>
                <p class="table_title">撥款狀態</p>
                <p class="table_content">{{this.$store.state.detailsList.withdrawal_status}}</p>
              </div>
              <div>
                <p class="table_title">付款方式</p>
                <p class="table_content">{{this.$store.state.detailsList.pay_type}}</p>
              </div>
            </div>
            <!-- 表單-end -->
            <!-- 按鈕-box -->
            <div class="button_box">
              <el-button plain @click="detailsBack()">返回訂單列表</el-button>
              <!-- <el-button type="primary">退款</el-button> -->
            </div>
            <!-- 按鈕-end -->
          </div>
          <!-- box-end -->
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'OrderDetails',
  props: {
  },
  data() {
    return {
     inquireTF: false
    }
  },
  components: {
  },
  methods: {
    detailsBack(){
      this.$emit('detailsFun');
    },
    // 選擇銀行：
    branchFun(){
        if(this.branchValue != '2'){
            this.payValue = '';
            this.paystart_time = '';
            this.payend_time = '';
        }
    },
    //判斷付款類型 
    typeFun(index){
        if(index == '1'){
            return '掃碼支付'
        }
        if(index == '2'){
            return 'Web支付'
        }
        if(index == '3'){
            return 'APP支付'
        }
        if(index == '4'){
            return '其他'
        }
    },
    //判斷交易類型 
    optionsFun(index){
        if(index == '1'){
            return '已支付'
        }
        if(index == '0'){
            return '未支付'
        }
    },
    //判斷撥款類型 
    statusFun(index){
        if(index == '1'){
            return '已撥款'
        } else {
            return '未撥款'
        }
    },
    // FUN-上一筆/下一筆
    detailsPN(id, branch, type){
      this.inquireTF = true;
      axios.get(this.$store.state.axiosDetailsUrl, {
          params: {
              id: id,
              branch: branch,
              branch_type: type,
              uid: this.$store.state.uid
          }
      }).then((res) => {
          // console.log(res.data.message);
          this.inquireTF = false;
          this.$store.commit('changeDetails',res.data.message);
      })
    },
  },
  computed: {
    // nextBranchType(){
    //   return this.$store.state.detailsList.next_branch_type;
    // },
    // previousBranchType(){
    //   return this.$store.state.detailsList.previous_branch_type;
    // },
    // previousId(){
    //   return this.$store.state.detailsList.previous_page;
    // },
    // nextId(){
    //   return this.$store.state.detailsList.next_page;
    // },
    // branchType(){
    //   return this.$store.state.detailsList.wm_branch;
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 内容 */
    .datetime_box > span {
      margin: 10px;
    }
    .deal_content_box {
      font-size: 13px;
      margin-top: 20px;
    }
    .deal_content_title {
      height: 42px;
      background: #666666;
      line-height: 42px; 
      color: white;
      padding-left: 14px;
    }
    .deal_content {
      color: #000000;
      box-sizing: border-box;
      border: 1px solid #666666;
      background: #ffffff;
      padding: 50px 66px;
    }

  /* 表格 */
  .content_box {
    /* width: 600px; */
  }
  .arrows_box {
    display: flex;
    justify-content: space-between;
  }
  .arrows_box > span {
    cursor: pointer;
  }
  .table_box {
      display: flex;
      flex-direction: column;
      margin-top: 20px;
  }
  .table_box > div {
    display: flex;
  }
  .table_box > div > p {
    border: 1px solid #e7e7e7;
    padding: 12px 0 12px 30px;
  }
  .table_box > div > p > span+span {
    margin-left: 55px;
  }
  .table_title {
    width: 180px;
  }
  .table_content {
    flex: 1;
  }
  .button_box {
    margin-top: 36px;
    display: flex;
    justify-content: flex-end;
  }
  .button_box .el-button {
    padding: 8px 20px;
  }
</style>
